import React from 'react';
import { VehicleStatusTypeColor, VehicleStatusTypeText } from 'src/types/IVehicle';

import { Results } from 'src/types/IVehicle'; 

import { TRBody, Dot } from './styles';

interface IProps {
  item: Results;
}

const GridItem = ({ item }: IProps) => {

  return (
    <TRBody>
      <td className='nowrap'>{item.name}</td>
      <td>{item.brand}</td>
      <td>{item.km}</td>
      <td>{new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(item.price)}</td>
      <td>{new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(item.fipePrice)}</td>
      <td>{item.year}/{item.yearModel}</td>
      <td>{item.licensePlate}</td>
      <td className='nowrap'>
        <Dot color={VehicleStatusTypeColor[item.status]} />
        {VehicleStatusTypeText[item.status]}
      </td>
    </TRBody>
  );
};

export default GridItem;
